const about = {
  breadcrumb_home: '首页',
  breadcrumb_about: '关于我们',
  hero_title: '关于布丁漫画网',
  hero_subtitle: '发现好漫画，从这里开始',
  hero_desc: '我们致力于为每一位漫画爱好者提供最优质的阅读体验，让好漫画触手可及。',
  section_brand_title: '品牌故事',
  section_brand_tag: '我们的初心',
  section_values_title: '核心价值',
  section_values_tag: '我们的坚持',
  section_milestones_title: '发展历程',
  section_milestones_tag: '一路走来',
  section_platform_title: '平台数据',
  section_platform_tag: '数据说话',
  section_contact_title: '联系我们',
  section_contact_tag: '保持联系',
  section_business_title: '商务合作',
  section_business_tag: '合作共赢',
  contact_address: '公司地址',
  contact_phone: '联系电话',
  contact_email: '联系邮箱',
  contact_business_email: '商务合作邮箱',
  contact_hours: '工作时间',
  form_title: '合作咨询',
  form_name: '您的姓名',
  form_company: '公司/机构名称',
  form_email: '联系邮箱',
  form_phone: '联系电话',
  form_type: '合作类型',
  form_type_content: '内容合作',
  form_type_ad: '广告投放',
  form_type_ip: 'IP授权',
  form_type_media: '媒体合作',
  form_type_other: '其他',
  form_message: '合作意向说明',
  form_submit: '提交咨询',
  form_success: '提交成功！我们将在1-3个工作日内与您联系。',
  form_error: '提交失败，请稍后重试。',
  form_sending: '提交中...',
};

export default about;